import { makeStyles } from "@material-ui/core/index.js";

export default makeStyles((theme) => ({
    mainContainer: {
        height: '100%',
        width: '100%',
        backgroundColor: '#cccccc',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        borderRadius: '4px',
    },
    chatWrap: {
        overflowY: 'auto',
        overflowX: 'hidden',
    },
    chatItem: {
        backgroundColor: '#f2f2f2',
        margin: '8px 0px',
        padding: '2px',
        boxSizing: 'border-box',
        width: '100%',
        display: 'flex',
        alignItems: 'flex-start',
        [theme.breakpoints.down('xs')]: {
            padding: '2px 0px',
        },
    },
    chatItemDetail: {
        display: 'flex',
        alignItems: 'center',
        fontWeight: '400',
        margin: '4px 0px 4px 0px',
        letterSpacing: '0.6px',
        width: '100%',
        justifyContent: 'space-between',
    },
    chatItemAvatar: {
        height: '34px',
        width: '34px',
        backgroundColor: '#e2e2e2',
        borderRadius: '20px',
        border: '2px solid #cccccc',
        margin: '4px 4px',
        objectFit: 'cover',
        '&:hover': {
            cursor: 'pointer',
        },
    },
    content: {
        width: 'calc(100% - 50px)',
        display: 'flex',
        backgroundColor: '#f2f2f2',
        flexDirection: 'column',
        padding: '4px 2px 4px 2px',
    },
    chatItemUser: {
        //color: '#107090',
        color: '#585858',
        fontSize: '15px',
        letterSpacing: '0.4px',
        marginLeft: '4px',
        fontWeight: '600',
        overflow: 'hidden',
        [theme.breakpoints.down('xs')]: {
            fontWeight: '500',
            fontSize: '13px', 
            marginLeft: '0px',
        },
    },
    chatItemTime: {
        marginRight: '6px',
        fontSize: '13px',
        color: '#888888',
        alignSelf: 'stretch',
        [theme.breakpoints.down('xs')]: {
            fontSize: '11px',
            marginRight: '4px',
        },
    },
    chatItemMsg: {
        fontFamily: 'Bai Jamjuree',
        letterSpacing: '0.4px',
        width: '100%',
        alignItems: 'center',
        boxSizing: 'border-box',
        padding: '2px 4px 4px 4px',
        overflowWrap: 'break-word',
        backgroundColor: '#f2f2f2',
        fontSize: '16px',
        [theme.breakpoints.down('xs')]: {
            fontSize: '13px',
            paddingLeft: '0px',
            paddingRight: '0px',
        },
    },
    chatItemBox: {
        height: '100%',
        width: '100%',
        backgroundColor: '#e8e8e8',
        display: 'flex',
        boxSizing: 'border-box',
        flexDirection: 'column',
        overflowY: 'auto',
        justifyContent: 'flex-end',
    },
    header: {
        padding: '5px',
        boxSizing: 'border-box',
    },
    footer: {
        height: '60px',
        width: '100%',
        backgroundColor: '#cccccc',
        display: 'flex',
        alignItems: 'center',
    },
    usericon: {
        fontSize: '22px',
        color: '#282828',
        float: 'right',
        '&:hover': {
            cursor: 'pointer',
        }
    },
    sendicon: {
        fontSize: '35px',
        color: '#282828',
        '&:hover': {
            cursor: 'pointer',
        },
        padding: '0px 4px',
        userSelect: 'none',
    },
    chatInput: {
        margin: '0px 4px 0px 8px',
        fontSize: '16px',
        width: '100%',
        border: '1px solid #aaaaaa',
        boxSizing: 'border-box',
        padding: '0px 8px',
        height: '70%',
        borderRadius: '8px',
        backgroundColor: '#eeeeee',
        '&:focus': {
            outline: 'none',
        },
        [theme.breakpoints.down('xs')]: {
            fontSize: '14px',
        },
    },
    userList: {
        position: 'absolute',
        left: '95%',
        overflowY: 'scroll',
        transform: 'translate(-100%, 0%)',
        width: '250px',
        maxWidth: '70%',
        backgroundColor: '#f8f8f8',
        display: 'none',
        fontSize: '15px',
        letterSpacing: '0.2px',
    },
    userListItem: {
        width: '100%',
        height: '56px',
        borderBottom: '2px solid #e2e2e2',
        boxSizing: 'border-box',
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'row',
        '&:hover': {
            cursor: 'pointer',
        },
    },
    userListAvatar: {
        height: '30px',
        width: '30px',
        objectFit: 'cover',
        borderRadius: '17px',
        margin: '0px 8px',
        border: '2px solid #cccccc',
    },
    userListName: {
        flexGrow: 1,
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        fontWeight: '500',
        color: '#333333',
        letterSpacing: '0.3px',
        [theme.breakpoints.down('xs')]: {
            fontSize: '14px',
        },
    },
    startContainer: {
        position: 'relative',
        width: '100%',
        height: '100%',
        color: '#282828',
        backgroundColor: '#e8e8e8',
        borderRadius: '4px',
        overflowY: 'auto',
        boxSizing: 'border-box',
    },
    startType: {
        position: 'relative',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'wrap',
        boxSizing: 'border-box',
        padding: '20px 0px',
    },
    startHeading: {
        width: '100%',
        fontWeight: '600',
        letterSpacing: '1px',
        fontSize: '30px',
        padding: '0px 20px',
        color: '#282828',
        boxSizing: 'border-box',
        marginBottom: '10px',
        [theme.breakpoints.down('sm')]: {
            padding: '0px 10px', 
        },
    },
    startDescription: {
        width: '100%',
        height: 'fit-content',
        padding: '4px 16px',
        boxSizing: 'border-box',
        borderRadius: '4px',
        color: '#505050',
        fontSize: '14px',
        lineHeight: '1.4',
        letterSpacing: '0.2px',
        [theme.breakpoints.down('sm')]: {
            padding: '4px 8px',
        },
    },
    textCenter: {
        padding: '40px 10px',
        boxSizing: 'border-box',
        width: '100%',
        fontWeight: '500',
        textAlign: 'center',
        color: '#282828',
    },
    formJoin: {
        width: 'fit-content',
        margin: '0px auto',
        display: 'flex',
        flexDirection: 'column',
        boxSizing: 'border-box',
        alignItems: 'center',
    },
    buttonRoom: {
        letterSpacing: '0.5px',
        marginTop: '16px',
        '&:hover': {
            backgroundColor: '#282828',
            color: '#e2e2e2',
        }
    },
    inputDiv: {
        display: 'flex',
        flexDirection: 'column',
        height: '80px',
        justifyContent: 'space-around',
        [theme.breakpoints.down('xs')]: {
            //flexDirection: 'column',
        },
    },
    checkbox: {
        margin: '2px 8px 0px 8px',
        [theme.breakpoints.down('xs')]: {
            margin: '2px 0px 0px -10px',
        },
    },
    formContainer: {
        display: 'flex',
        alignItems: 'flex-end',
        paddingLeft: '10px',
        [theme.breakpoints.down('xs')]: {
            flexDirection: 'column',
            alignItems: 'flex-start',
        },
    },
}))